<template>
    <div class="register-modal">
        <el-dialog
            v-model="modelValueState"
            @closed="() => { resetModal(); $emit('closed'); }"
            :show-close="false"
        >
            <template #header>
                <div>
                    <img :src="$config.header_logo_url" />
                </div>
                <CloseModalButton @click="modelValueState = false" />
            </template>
            <template v-if="successMessage">
                <el-row>
                    <div class="success-wrapper">{{ successMessage }}</div>
                </el-row>
            </template>
            <template v-else>
                <el-row>
                    <el-col :span="24" class="title-col">
                        <div>
                            {{ $trans("web_search.checkout_register_modal.modal_title") }}
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div v-if="successMessage">
                            {{ successMessage }}
                        </div>
                        <el-form
                            v-else
                            ref="formRef"
                            label-position="top"
                            label-width="100px"
                            :model="formData"
                            :rules="rules"
                            :show-message="true"
                            :validate-on-rule-change="false"
                            require-asterisk-position="right"
                        >
                            <el-form-item class="flex-wrap-on-mobile">
                                <el-col :span="6" style="padding-left: 0">
                                    <el-form-item
                                        :label="$trans('web_search.checkout_fields.salutation')"
                                        required
                                        prop="salutation_id"
                                    >
                                        <el-select
                                            v-model="formData.salutation_id"
                                            placeholder="Salutation"
                                            :validate-event="false"
                                            class="web-search-select"
                                            autocomplete="off"
                                        >
                                            <el-option
                                                :label="$trans('messages.salutations.male_salutation_key')"
                                                value="1"
                                            />
                                            <el-option
                                                :label="$trans('messages.salutations.female_salutation_key')"
                                                value="2"
                                            />
                                            <el-option
                                                :label="$trans('messages.salutations.male_dr_salutation_key')"
                                                value="3"
                                            />
                                            <el-option
                                                :label="$trans('messages.salutations.female_dr_salutation_key')"
                                                value="4"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="9">
                                    <el-form-item
                                        :label="$trans('web_search.checkout_fields.first_name')"
                                        required
                                        prop="first_name"
                                        autocomplete="off"
                                    >
                                        <el-input
                                            v-model="formData.first_name"
                                            :validate-event="false"
                                        />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="9" style="padding-right: 0">
                                    <el-form-item
                                        :label="$trans('web_search.checkout_fields.last_name')"
                                        required
                                        prop="last_name"
                                        autocomplete="off"
                                    >
                                        <el-input
                                            v-model="formData.last_name"
                                            :validate-event="false"
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-form-item>
                            <el-form-item
                                :label="$trans('web_search.checkout_fields.company_name')"
                                required
                                prop="company_name"
                                autocomplete="off"
                            >
                                <el-input
                                    v-model="formData.company_name"
                                    :validate-event="false"
                                />
                            </el-form-item>
                            <el-form-item
                                :label="$trans('web_search.checkout_fields.email')"
                                required
                                prop="email"
                                autocomplete="off"
                            >
                                <el-input
                                    v-model="formData.email"
                                    :validate-event="false"
                                    disabled
                                />
                            </el-form-item>
                            <el-form-item
                                :label="$trans('web_search.checkout_fields.phone')"
                                required
                                prop="phone"
                                autocomplete="off"
                            >
                                <el-input
                                    v-model="formData.phone"
                                    :validate-event="false"
                                />
                            </el-form-item>
                            <el-form-item
                                :label="$trans('web_search.checkout_fields.password')"
                                required
                                prop="password"
                                autocomplete="off"
                            >
                                <el-input
                                    type="password"
                                    v-model="formData.password"
                                    :validate-event="false"
                                />
                            </el-form-item>
                            <el-form-item
                                :label="$trans('web_search.checkout_fields.password_confirmation')"
                                required
                                prop="password_confirmation"
                                autocomplete="off"
                            >
                                <el-input
                                    type="password"
                                    v-model="formData.password_confirmation"
                                    :validate-event="false"
                                />
                            </el-form-item>
                            <el-form-item required prop="agree">
                                <el-checkbox
                                    v-model="formData.agree"
                                    id="agreeCb"
                                    :validate-event="false"
                                    autocomplete="off"
                                />
                                <div style="margin-left: 10px; line-height: 18px">
                                    <div>
                                        <span>* {{ $trans("web_search.checkout_register_modal.consent") }}</span>
                                    </div>
                                    <div>
                                        <span v-html="$trans('web_search.checkout_register_modal.here_you_find_privacy_policy').replace(':privacy_policy_url', 'https://www.deutscheinterim.com/datenschutz')"></span>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item class="center" v-if="message">
                                <div class="error-wrapper">
                                    {{ message }}
                                </div>
                            </el-form-item>
                            <el-form-item class="center">
                                <el-button :loading="isSubmitting" @click="onSubmit()">
                                    {{ $trans("web_search.checkout_register_modal.button") }}
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </template>
            <template #footer v-if="!successMessage">
                <AuthFooterModal />
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { VueRecaptcha } from "vue-recaptcha";
import AuthFooterModal from "./../Auth/AuthFooterModal";
import CloseModalButton from "./CloseModalButton";
import { mapStores } from "pinia";
import { useCandidateBoardStore } from "@/stores/CandidateBoardStore";

export default {
    props: ["modelValue", "formDataProp"],
    emits: ["update:modelValue", "closed"],
    components: {
        AuthFooterModal,
        CloseModalButton,
        VueRecaptcha,
    },
    data() {
        return {
            isSubmitting: false,
            modelValueState: false,
            message: false,
            successMessage: false,
            errors: {
                board_name: "",
                salutation_id: "",
                first_name: "",
                last_name: "",
                company_name: "",
                email: "",
                phone: "",
                password: "",
                password_confirmation: "",
                agree: "",
                recaptcha_response: "",
            },
            formData: {
                board_name: "",
                salutation_id: "",
                first_name: "",
                last_name: "",
                company_name: "",
                email: "",
                phone: "",
                password: "",
                password_confirmation: "",
                agree: false,
                recaptcha_response: null,
            },
            rules: {
                salutation_id: [
                    {
                        required: true,
                        message: this.$trans("web_search.checkout_field_errors.required"),
                    },
                ],
                first_name: [
                    {
                        required: true,
                        message: this.$trans("web_search.checkout_field_errors.required"),
                    },
                ],
                last_name: [
                    {
                        required: true,
                        message: this.$trans("web_search.checkout_field_errors.required"),
                    },
                ],
                company_name: [
                    {
                        required: true,
                        message: this.$trans("web_search.checkout_field_errors.required"),
                    },
                ],
                email: [
                    {
                        required: true,
                        message: this.$trans("web_search.checkout_field_errors.required_email"),
                        type: "email",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: this.$trans("web_search.checkout_field_errors.required"),
                    },
                ],
                password: [
                    {
                        required: true,
                        message: this.$trans("web_search.checkout_field_errors.min_length").replace(":min", 6),
                        min: 6,
                    },
                ],
                password_confirmation: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value === "") {
                                callback(new Error(this.$trans("web_search.checkout_field_errors.required")));
                            } else if (value !== this.formData.password) {
                                callback(new Error(this.$trans("web_search.checkout_field_errors.password_confirmation_dont_match")));
                            } else {
                                callback();
                            }
                        },
                    },
                ],
                agree: [
                    {
                        required: true,
                        message: this.$trans("web_search.checkout_field_errors.accepted"),
                        type: "enum",
                        enum: [true],
                    },
                ],
                recaptcha_response: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.$trans("web_search.checkout_field_errors.required")));
                            } else {
                                callback();
                            }
                        },
                    },
                ],
            },
        };
    },
    computed: {
        ...mapStores(useCandidateBoardStore),
    },
    methods: {
        onVerifyRecaptcha: function (response) {
            this.formData.recaptcha_response = response;
        },
        onExpiredRecaptcha: function () {
            this.formData.recaptcha_response = null;
        },
        async onSubmit() {
            if (this.isSubmitting) return;

            var self = this;

            await this.$refs.formRef.validate((valid, fields) => {
                if (valid) {
                    self.isSubmitting = true;
                    const register = this.ajaxRegister();

                    register.then(function (result) {
                        if (result.status == "success") {
                            self.successMessage = result.message;
                        } else {
                            self.message = result.message;
                            self.isSubmitting = false;
                        }
                    }).catch(function() {
                        self.isSubmitting = false;
                    });
                }
            });
        },
        async ajaxRegister() {
            const questionInput = document.getElementById("search-input");
            let questionValue = questionInput.value.trim();

            const response = await fetch("/api/web-search/register-and-create-vacancy", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    vacancy_name: this.formData.board_name,
                    vacancy_managers: this.CandidateBoardStore.getProfileIds(),
                    vacancy_manager_criterias: this.CandidateBoardStore.getProfileCriterias(),
                    salutation_id: this.formData.salutation_id,
                    first_name: this.formData.first_name,
                    last_name: this.formData.last_name,
                    company_name: this.formData.company_name,
                    email: this.formData.email,
                    phone: this.formData.phone,
                    password: this.formData.password,
                    password_confirmation: this.formData.password_confirmation,
                    question_value: questionValue,
                    agree: this.formData.agree,
                    "g-recaptcha-response": this.formData.recaptcha_response,
                    _token: document.head.querySelector('meta[name="csrf-token"]').content,
                }),
            });

            return await response.json();
        },
        resetModal() {
            this.message = false;
            this.successMessage = false;
            this.isSubmitting = false;

            this.formData = {
                board_name: "",
                salutation_id: "",
                first_name: "",
                last_name: "",
                company_name: "",
                email: "",
                phone: "",
                password: "",
                password_confirmation: "",
                agree: false,
                recaptcha_response: null,
            };

            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
        },
    },
    watch: {
        modelValue: function () {
            this.modelValueState = this.modelValue;
        },
        formDataProp: function () {
            this.formData = { ...this.formData, ...this.formDataProp };
        },
    },
};
</script>

<style scoped>
.register-modal :deep(.el-dialog) {
    --el-dialog-width: 750px;
    top: -100px !important;
}

.center {
    text-align: center;
}

.success-wrapper {
    color: #81bc8f;
    text-align: center;
    font-weight: bold;
    width: 100%;
}

.error-wrapper {
    color: #ff6b65;
    font-style: italic;
}

.register-modal :deep(.el-dialog .el-dialog__header) {
    padding-bottom: 0;
}

.register-modal :deep(.el-dialog .el-dialog__body) {
    padding-bottom: 20px;
}

.register-modal :deep(.el-dialog .el-dialog__footer) {
    padding: 0;
}

.register-modal
    :deep(
        .el-form--default.el-form--label-top .el-form-item .el-form-item__label
    ) {
    margin-bottom: 0px;
}

.register-modal :deep(.center .el-form-item__content) {
    justify-content: center;
}

.register-modal :deep(.el-form-item__content) {
    flex-wrap: unset;
}

.login-modal :deep(.el-form-item:last-child) {
    margin-bottom: 0;
}

.register-modal .el-row {
    background-color: #ededed;
    color: rgb(60, 60, 60);
    padding-bottom: 18px;
}

.register-modal .el-row:first-child {
    padding-top: 18px;
}

.register-modal .el-col {
    padding: 0 15px;
}

.register-modal .title-col div {
    text-align: left;
    font: normal normal 500 24px/29px Barlow;
    letter-spacing: -0.24px;
    color: #3c3c3c;
    padding-top: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgb(60, 60, 60);
}

.register-modal .el-button {
    background-color: #41abc4;
    color: #fff;
    border-radius: 4px;
    height: 40px;
    width: 100%;
    max-width: 80%;
    font-size: 18px;
    font-weight: 300;
}

.register-modal .el-button:hover {
    background-color: #2699b2;
}

.register-modal .el-checkbox {
    --el-checkbox-font-size: 14px;
    --el-checkbox-font-weight: var(--el-font-weight-primary);
    --el-checkbox-text-color: #3c3c3c;
    --el-checkbox-input-height: 14px;
    --el-checkbox-input-width: 14px;
    --el-checkbox-border-radius: 0;
    --el-checkbox-bg-color: white;
    --el-checkbox-input-border: 1px solid #41abc4;
    --el-checkbox-disabled-border-color: var(--el-border-color);
    --el-checkbox-disabled-input-fill: var(--el-fill-color-light);
    --el-checkbox-disabled-icon-color: var(--el-text-color-placeholder);
    --el-checkbox-disabled-checked-input-fill: var(
        --el-border-color-extra-light
    );
    --el-checkbox-disabled-checked-input-border-color: var(--el-border-color);
    --el-checkbox-disabled-checked-icon-color: var(--el-text-color-placeholder);
    --el-checkbox-checked-text-color: #3c3c3c;
    --el-checkbox-checked-input-border-color: #41abc4;
    --el-checkbox-checked-bg-color: #41abc4;
    --el-checkbox-checked-icon-color: var(--el-color-white);
    --el-checkbox-input-border-color-hover: #41abc4;

    height: 24px;
}

.register-modal a,
.register-modal a:hover,
.register-modal a:visited {
    color: rgb(60, 60, 60);
}

/* max-wdith = width of modal + 50px */
@media only screen and (max-width: 800px) {
    .register-modal :deep(.el-dialog) {
        --el-dialog-width: 95%;
        margin-top: 50px;
    }

    .register-modal :deep(.flex-wrap-on-mobile .el-form-item__content) {
        flex-wrap: wrap;
    }

    .register-modal .el-col-6,
    .register-modal .el-col-9 {
        max-width: 100%;
        flex: 0 0 100%;
        padding: 0;
    }

    .register-modal .el-col-6:not(:last-child),
    .register-modal .el-col-9:not(:last-child) {
        margin-bottom: 18px;
    }

    .register-modal .el-button {
        white-space: unset;
        height: unset;
    }
}
</style>
